import { createFetchAction } from '../utils';
import * as impactAssessmentActionTypes from './impactAssessmentActionTypes';

export const fetchImpactAssessmentActions = createFetchAction(
  impactAssessmentActionTypes.FETCH_IMPACT_ASSESSMENT_ACTIONS,
  'impactAssessmentId',
);
